function is_zoom()
{
    return space_product_image_zoom;
}
( function( $ ) {
    "use strict";

    $( document ).ready(function() {
        if( space_product_image_zoom == undefined)
        {
            var  space_product_image_zoom = is_zoom();
        }
        if(space_product_image_zoom)
        {
            $(".my-foto").imagezoomsl({magnifiersize:[300,550]}); 
        }
        $("#product-thumb-slide").verticalCarousel({nSlots: 4, speed: 400});
        //Color Filter
        $('.sortby .dropdown-select').on('click','li',function(){
            var value = $(this).attr('swatch-value');

            var $form = $(this).closest('form');
            var $ul = $(this).closest('ul');
            var name = $ul.attr('name');
            $('input[name="'+name+'"]').val(value);
            $form.trigger('submit');
        });

        //price filter
        // $('.sortby select#price_range').on('change',function(){
        //     var $form = $(this).closest('form');
        //     var val = $(this).val();
        //     if(val != '')
        //     {
        //         var tmp = val.split(',');
        //         if(tmp.length == 2)
        //         {
        //             $('input[name="min_price"]').val(tmp[0]);
        //             $('input[name="max_price"]').val(tmp[1]);
        //         }
        //     }

        //     $form.trigger('submit');
        // });

        $('.catalog-swatch').on('click',function(){
            var swatch = $(this).attr('swatch');
            if(swatch)
            {
                if($(this).closest('.item-wrap').find('img[swatch="'+swatch+'"]').length > 0)
                {
                    $(this).closest('.item-wrap').find('img').each(function(){
                        if($(this).attr('swatch') == swatch)
                        {
                            $(this).show();
                        }else{
                            $(this).hide();
                        }
                    });
                }

            }
        })

        //Product filter
        // $('select.swatch-filter').on('change',function(){
        //     $(this).closest('form').trigger('submit');
        // });

        //Change thumbnail
        if(!space_product_image_zoom)
        {
            $('body').on('hover','.thumbnails a.img-thumb',function(){

                var src = $(this).attr('href');
                $(this).closest('.images').find('.main-image a').attr('href',src);
                $(this).closest('.images').find('.main-image a img').attr('src',src);
                var srcset =  $(this).find('img').first().attr('srcset');
                if(srcset)
                {
                    $(this).closest('.images').find('.main-image a img').attr('srcset',srcset);
                }else{
                    $(this).closest('.images').find('.main-image a img').attr('srcset','');
                }
                if(space_product_image_zoom)
                {
                    var base = $(this).attr('data-big');
                    $(this).closest('.images').find('.main-image a img').attr('data-large',base);
                    if( !space_product_ajax_load)
                    {
                        $(".my-foto").imagezoomsl({magnifiersize:[300,550]});
                    }

                }
            });
        }


        $('body').on('click','.thumbnails a.img-thumb',function(event){
            event.preventDefault();
            var src = $(this).attr('href');
            $(this).closest('.images').find('.main-image a').attr('href',src);
            $(this).closest('.images').find('.main-image a img').attr('src',src);
            var srcset =  $(this).find('img').first().attr('srcset');
            if(srcset)
            {
                $(this).closest('.images').find('.main-image a img').attr('srcset',srcset);
            }else{
                $(this).closest('.images').find('.main-image a img').attr('srcset','');
            }
            if(space_product_image_zoom)
            {
                var base = $(this).attr('data-big');
                $(this).closest('.images').find('.main-image a img').attr('data-large',base);
                if( !space_product_ajax_load)
                {
                    $(".my-foto").imagezoomsl({magnifiersize:[300,550]});
                }
            }
        });

        //Update product quantity
        $('body').on('click','.fa-angle-up',function(){
            var qty = $(this).closest( ".quantity").find('input.qty').val();
            $(this).closest( ".quantity").find('input.qty').val(parseInt(qty) + 1).trigger('change');
        });
        $('body').on('click','.fa-angle-down',function(){
            var qty = $(this).closest( ".quantity").find('input.qty').val();
            if(parseInt(qty) > 0)
            {
                $(this).closest( ".quantity").find('input.qty').val(parseInt(qty) - 1).trigger('change');
            }
        });

        //Quick View
        $('body').on('click', '.quick-view', function() {
            var url = $(this).data('href');
            var productId = $(this).attr('product-data');
            var html = '<div class="look-page-loading">Loading....</div>';
            $.ajax({
                url: url,
                type: 'GET',
                data: {
                    view: 'quickview'
                },
                beforeSend: function() {
                    $('body').append(html);
                },
                success: function(data) {
                    $('.look-page-loading').remove();
                    $('.product-quickview-content').html(data);
                    $("#myModal").modal();
                    if (typeof($('.variations_form').wc_variation_form) === "function") {
                        $('.variations_form').wc_variation_form();
                    }
                    $('.variations_form .variations select').change();
                    $("#product-thumb-slide").verticalCarousel({
                        nSlots: 4,
                        speed: 400
                    });
                   ConvertCurrency();
                }
            });
        });

        //ajax search
        if(typeof space_ajax_search != undefined && parseInt(space_ajax_search) == 1 )
        {
            $( ".search-field" ).autocomplete({
                source: function( request, response ) {
                    $.ajax({
                        url: space_ajax_url ,
                        dataType: "json",
                        data: {
                            q: request.term,
                            action: 'look_search_products'
                        },
                        success: function( data ) {
                            response( data );
                        }
                    });
                },
                minLength: 2,
                select: function( event, ui ) {
                    window.location = ui.item.url;
                },
                open: function() {
                    $( this ).removeClass( "ui-corner-all" ).addClass( "ui-corner-top" );
                },
                close: function() {
                    $( this ).removeClass( "ui-corner-top" ).addClass( "ui-corner-all" );
                }
            }).data( "ui-autocomplete" )._renderItem = function( ul, item ) {
                if(typeof space_ajax_search_thumbnail != undefined && parseInt(space_ajax_search_thumbnail) == 1)
                {
                    return $( "<li>" )
                        .data( "ui-autocomplete-item", item )
                        .attr( "data-url", item.url )
                        .append( "<img class='ajax-result-item' src='"+item.thumb+"'><a class='ajax-result-item-name' href='"+item.url+"'>" + item.label + "</a>" )
                        .appendTo( ul );
                }else{
                    return $( "<li>" )
                        .data( "ui-autocomplete-item", item )
                        .attr( "data-url", item.url )
                        .append( "<a class='ajax-result-item-name' href='"+item.url+"'>" + item.label + "</a>" )
                        .appendTo( ul );
                }
            };
        }
        function preloadPage(next_page,page)
        {
            var obj = $('.pagination-ajax');
            var base_url = obj.data('base');
            var total_page = obj.data('total');
            var url = base_url.replace("%#%", next_page);
            var $grid = $('.grid-mansory').masonry({
                itemSelector: '.grid-item'
            });
            $.ajax({
                url: url,
                data:{view:'ajax',
                page:next_page
            },
                beforeSend: function(){
                    obj.addClass('loading');
                },
                success: function(data){
                    var elements = $(data);
                    $grid.append( elements );
                    $('.grid-mansory').waitForImages({
                        finished: function() {
                            $grid.masonry('appended',elements);
                        }
                    });
                    obj.removeClass('loading');
                    obj.data('current',next_page);

                    if(next_page >= total_page )
                    {
                        obj.hide();
                    }else{
                        if(next_page < page)
                        {
                            next_page++;
                            preloadPage(next_page,page)
                        }
                    }

                }
            });

        }
        $('.grid-mansory').waitForImages({
            finished: function() {
                if($('.item-wrap').length > 0)
                {
                    var $grid = $('.grid-mansory').masonry({
                        // options
                        itemSelector: '.grid-item'
                        //columnWidth: 400
                    });
                    var param = document.URL.split('#')[1];
                    if(param && parseInt(param) > 1)
                    {

                        preloadPage(2,parseInt(param));
                    }
                    $('body').on('click','.pagination-ajax',function(){
                        var obj = $(this);
                        var base_url = $(this).data('base');
                        var current_page = $(this).data('current');
                        var total_page = $(this).data('total');
                        var next_page = parseInt(current_page) + 1;
                        var url = base_url.replace("%#%", next_page);
                        if(!obj.hasClass('loading'))
                        {
                            $.ajax({
                                url: url,
                                data:{
                                    view:"ajax",
                                    page:next_page

                                },
                                beforeSend: function(){
                                    obj.addClass('loading');
                                },
                                success: function(data){
                                    var elements = $(data);
                                    $grid.append( elements );
                                    $('.grid-mansory').waitForImages({
                                        finished: function() {
                                            $grid.masonry('appended',elements);
                                        }
                                    });
                                    obj.removeClass('loading');
                                    if(next_page >= total_page )
                                    {
                                        obj.hide();
                                    }
                                    window.location.hash = next_page;
                                    obj.data('current',next_page);
                                }
                            });
                        }
                    });
                }

            },

            waitForAll: true
        });


    });
} )( jQuery );